import { createStore } from 'zustand';
import { ISubmission, IAssignment } from '@/components/interfaces';
import * as Interfaces from '../types';

interface GradesTableStoreVariables {
  assignments: IAssignment[];
  assignmentsAssigneeModels: Interfaces.IAssignmentAssigneeModel[];
  classroom: Interfaces.IClassroom;
  filters: Interfaces.Filters;
  isImpersonating: boolean;
  isLoading: () => boolean;
  isLoadingStudents: boolean;
  isLoadingAssignments: boolean;
  lesson: Interfaces.ILesson;
  navigationParams: () => Record<string, string | number>;
  programId: number;
  showBenchmarksButton: boolean;
  stafferId: number;
  students: Interfaces.IStudent[];
  submissions: ISubmission[];
  unit: Interfaces.IUnit;
  lowScoresSettings: Interfaces.LowScoreSettings;
}

export interface UseGradesTableState extends GradesTableStoreVariables {
  setFilter: (filter) => void;
  setStore: (nextState: Partial<GradesTableStoreVariables>) => void;
}

const createGradesTableStore = (props: Interfaces.AssignmentsBasedGradesTableProps) => (
  createStore<UseGradesTableState>()((set, get) => ({
    ...props,
    assignments: [],
    assignmentsAssigneeModels: [],
    filters: {
      completionStatus: [],
      gradingStatus: [],
    },
    isLoading: () => {
      const { isLoadingAssignments, isLoadingStudents } = get();
      return isLoadingAssignments || isLoadingStudents;
    },
    isLoadingAssignments: true,
    isLoadingStudents: true,
    navigationParams: () => {
      const { classroom, lesson, unit } = get();
      const lessonOrUnitId = lesson ? { lesson_id: lesson.id } : { unit_id: unit.id };

      return {
        classroom_id: classroom.id,
        ...lessonOrUnitId,
      };
    },
    setFilter: filter => set(prevState => ({ ...prevState, filters: { ...prevState.filters, ...filter } })),
    setStore: nextState => set(prevState => ({ ...prevState, ...nextState })),
    showBenchmarksButton: false,
    students: [],
    submissions: [],
  }))
);

export default createGradesTableStore;
